import * as React from 'react';
import * as styles from './PixelTemplate.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var PixelTemplate = function PixelTemplate() {
  return /*#__PURE__*/_jsx("div", {
    className: styles['container']
  });
};